import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  Header,
  Body,
  Footer,
  Close
} from "MODULES/shared/components/Modal";
import Warning from "MODULES/shared/components/Warning/Warning";

export default function TransitionConfirmAction({
  onConfirm,
  open,
  close,
  children,
  warningWrapper = true,
  btnClass = "btn-primary",
  btnText = "Okay",
  showButton = true,
  cancelText = "Cancel",
  icon = <i className="fa fa-fw fa-check" />,
  message = "Are you sure you want to do this?",
  modalSize = "modal-sm"
}) {
  const [disabled, setDisabled] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const confirm = () => {
    setDisabled(true);
    setIsSubmitting(true);

    onConfirm().finally(() => {
      setIsSubmitting(false);
      close();
      setDisabled(false);
    });
  };

  return (
    <Modal open={open} close={close} dialogClass={modalSize}>
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Are You Sure?</h4>
      </Header>
      <Body>
        {warningWrapper ? (
          <Warning>
            {children || (
              <span>
                <strong>Heads up!</strong> {message}
              </span>
            )}
          </Warning>
        ) : (
          <div>
            {children || (
              <span>
                <strong>Heads up!</strong> {message}
              </span>
            )}
          </div>
        )}
      </Body>
      <Footer>
        <button type="button" className="btn btn-default" onClick={close}>
          {cancelText}
        </button>
        {showButton && (
          <button
            type="button"
            className={`btn ${btnClass}`}
            onClick={confirm}
            disabled={disabled}
          >
            {isSubmitting ? (
              <i className="fa fa-cog fa-spin fa-fw fa-lg" />
            ) : (
              icon
            )}{" "}
            {isSubmitting ? "Saving" : btnText}
          </button>
        )}
      </Footer>
    </Modal>
  );
}

TransitionConfirmAction.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  warningWrapper: PropTypes.bool,
  showButton: PropTypes.bool,
  btnClass: PropTypes.string,
  btnText: PropTypes.string,
  cancelText: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  icon: PropTypes.node,
  message: PropTypes.string,
  modalSize: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/TransitionConfirmAction/TransitionConfirmAction.jsx